import type { Chain } from '../../../chain';
import type { WalletProvider } from '../../../wallets/walletProvider/walletProvider.types';

export const getChainIdForAccountVerification = async ({
  walletProvider,
}: {
  walletProvider: WalletProvider;
}) => {
  // for some chains, we don't need to specify a chain id for account verification because it's
  // not required and it might break the message signature in some wallets (e.g. Trust Wallet SOL)
  const chainsThatDontNeedChainId: Chain[] = ['BTC', 'SOL', 'SUI'];

  if (chainsThatDontNeedChainId.includes(walletProvider.chain)) {
    return undefined;
  }

  const { networkId } = await walletProvider.getActiveNetworkId();

  if (networkId) {
    return networkId;
  }

  // default to ethereum mainnet
  if (walletProvider.chain === 'EVM') {
    return '1';
  }

  return undefined;
};
